import axios from "axios";
import Config from "../../config/";
import moment from 'moment';
const API_KEY = Config.apikey;
const ROOT_URL = Config.rooturl;

export function cekAuth() {
  return {
    headers: {
      'Authorization': localStorage.getItem('token')
    }
  };
}

export function fetchCms(type) {
    const url = `${ROOT_URL}cms?type=${type}`;

    const request = axios.get(
      url, cekAuth(), {
      onUploadProgress: progressEvent => {
        console.log(progressEvent.loaded / progressEvent.total);
      }
    });
    return request;

}
  
export function postCms(datanya) {
    const url = `${ROOT_URL}cms`;
    const request = axios.post(url, datanya, cekAuth());
    return request;
}

export function deleteCms(dictID) {
    const url = `${ROOT_URL}cms/${dictID}`;
    const request = axios.delete(url, cekAuth());
    return request;
}

export function putCms(datanya) {
    console.log(datanya);
    const url = `${ROOT_URL}cms/${datanya.cmsId}`;

    const request = axios.put(
      url, datanya ,cekAuth(), {
      onUploadProgress: progressEvent => {
        console.log(progressEvent.loaded / progressEvent.total);
      }
    });
    return request;

}
